import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faChevronLeft, faChevronRight, faCopy, faFilter, faFilterCircleXmark, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiService } from '../../../services/apiService';
import Box from '@mui/material/Box';
import { MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TaskTabs from '../../../components/common/TaskTabs';
import Select from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import DatePickerCustom from '../../../components/common/DatePickerCustom';
import dayjs from 'dayjs';
import { Modal } from 'react-bootstrap';
import { faCircleDown } from '@fortawesome/free-regular-svg-icons';
import ExportDialogs from '../../../components/exporttable/ExportDialogs';
import { useTableExport } from '../../../components/exporttable/useTableExport';
// const profileImage = require('../../../assets/defaultprofile.svg').default;
function MyCases() {
    const navigate = useNavigate();

    // 🔹 session storage helpers
    const SS_PREFIX = 'myCases_';
    const getStored = (key, fallback) => {
        try {
            const v = sessionStorage.getItem(SS_PREFIX + key);
            return v !== null ? JSON.parse(v) : fallback;
        } catch {
            return fallback;
        }
    };

    // 🔹 build the lane-view applied payload from stored selections (mirrors handleSearch)
    const buildLanePayload = () => {
        const payload = {};
        const addIfNotEmpty = (key, arr) => {
            if (arr?.length) {
                payload[key] = arr.map(({ value }) => Number(value));
            }
        };
        addIfNotEmpty("case_type_id", getStored('selectedCaseType', []));
        addIfNotEmpty("case_subtype_id", getStored('selectedCaseSubType', []));
        addIfNotEmpty("business_entity_id", getStored('selectedBussEntity', []));
        addIfNotEmpty("ownership_group_id", getStored('selectedOwnGroup', []));
        addIfNotEmpty("solution_id", getStored('selectedSolutions', []));
        const f = getStored('laneFilter', null);
        if (f?.created_on) {
            payload.created_on = f.created_on;
            if (f.created_on === 'custom') {
                if (f.start_date) payload.start_date = f.start_date;
                if (f.end_date) payload.end_date = f.end_date;
            }
        }
        return payload;
    };

    const [myrequests, setMyRequests] = useState([]);
    const [myrequests2, setMyRequests2] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingApply, setLoadingApply] = useState(false);
    const [loadingApply2, setLoadingApply2] = useState(false);
    const [selectedCase, setSelectCase] = useState(() => getStored('selectedCase', "general"));
    const [groupByColumn, setGroupByColumn] = useState(() => getStored('groupByColumn', 'stage'));
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => getStored('columnVisibility', {}));

    const [laneLoading, setLaneLoading] = useState({});
    const pageRefs = useRef({}); // { [group_id]: currentPage }
    const searchParamsRef = useRef(buildLanePayload());
    const fetchMyRequest = useCallback(async (params = {}, columnPage = null, showLoader = true) => {
        // Only show full loader when it's not a pagination request
        if (showLoader) setLoadingApply2(true);
        if(selectedCase === "general"){
        try {
            const defaultParams = {
                case_type: selectedCase,
                case_scope: "assigned",
                view: "lane",
                group_by: groupByColumn,
                ...params,
                ...searchParamsRef.current,
                ...(columnPage && { column_page: columnPage }),
            };

            const response = await apiService.postRequest(`/my-cases`, defaultParams);

            if (response.success === true) {
                if (columnPage) {
                    // PAGINATION: append data only to matching lanes
                    setMyRequests2(prev =>
                        prev.map(lane => {
                            const groupId = String(lane.group_id);
                            if (columnPage[groupId]) {
                                const incomingLane = response.columns.find(
                                    col => String(col.group_id) === groupId
                                );
                                if (incomingLane) {
                                    return {
                                        ...lane,
                                        data: [...(lane.data || []), ...(incomingLane.data || [])],
                                        has_more: incomingLane.has_more,
                                        total: incomingLane.total,
                                    };
                                }
                            }
                            return lane;
                        })
                    );
                } else {
                    // FRESH LOAD: replace all data & reset pages
                    pageRefs.current = {};
                    setMyRequests2(response.columns);
                    setFilters([{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
                }
            }
        } catch (error) {
            console.error('Error fetching list:', error);
        } finally {
            if (!columnPage) setLoading(false);
            setLoadingApply2(false);
        }
    }
    }, [selectedCase, groupByColumn]);


    const handleLoadMore = useCallback(async (groupId) => {
        if (laneLoading[groupId]) return;

        setLaneLoading(prev => ({ ...prev, [groupId]: true }));

        try {
            const nextPage = (pageRefs.current[groupId] || 1) + 1;
            pageRefs.current[groupId] = nextPage;

            const columnPage = { [groupId]: nextPage };

            await fetchMyRequest({}, columnPage);
        } catch (err) {
            console.error('Failed to load more:', err);
        } finally {
            setLaneLoading(prev => ({ ...prev, [groupId]: false }));
        }
    }, [laneLoading, fetchMyRequest]);


    const handleSearch = () => {
        const payload = {};

        const addIfNotEmpty = (key, arr) => {
            if (arr?.length) {
                payload[key] = arr.map(({ value }) => Number(value));
            }
        };

        addIfNotEmpty("case_type_id", selectedCaseType);
        addIfNotEmpty("case_subtype_id", selectedCaseSubType);
        addIfNotEmpty("business_entity_id", selectedBussEntity);
        addIfNotEmpty("ownership_group_id", selectedOwnGroup);
        addIfNotEmpty("solution_id", selectedSolutions);

        if (filter?.created_on) {
            payload.created_on = filter.created_on;
            if (filter.created_on === 'custom') {
                if (filter.start_date) payload.start_date = filter.start_date;
                if (filter.end_date) payload.end_date = filter.end_date;
            }
        }

        // Reset pages on new search
        searchParamsRef.current = payload;
        pageRefs.current = {};
        fetchMyRequest(payload);
    };

    const handleClear = () => {
        // Clear all selected dropdowns
        setSelectedCaseType([]);
        setSelectedCaseSubType([]);
        setSelectedBussEntity([]);
        setSelectedOwnGroup([]);
        setSelectedSolutions([]);

        // Reset filter object
        setFilter({
            created_on: "",
            start_date: "",
            end_date: ""
        });

        // Reset stored search params
        searchParamsRef.current = {};

        // Reset pagination
        pageRefs.current = {};

        // Fetch default data (without filters)
        fetchMyRequest({}, null, false);
    };

    useEffect(() => {
        fetchMyRequest();
    }, [fetchMyRequest]);


    const observerRefs = useRef({});

    const setObserver = useCallback((groupId, hasMore) => (node) => {
        // Disconnect existing observer for this lane
        if (observerRefs.current[groupId]) {
            observerRefs.current[groupId].disconnect();
            delete observerRefs.current[groupId];
        }

        if (!node || !hasMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    handleLoadMore(groupId);
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(node);
        observerRefs.current[groupId] = observer;
    }, [handleLoadMore]);

    useEffect(() => {
        if(selectedCase && selectedCase !== "general"){
            setLaneView(false);
        }else{
            setLaneView(true);
        }
    }, [selectedCase]);
    // Cleanup all observers on unmount
    useEffect(() => {
    const observers = observerRefs.current; // 👈 copy to local variable
        return () => {
            Object.values(observers).forEach(obs => obs.disconnect());
        };
    }, []);

    const [isGridVisible, setGridVisible] = useState(false);
    const [showLaneview, setLaneView] = useState(true);
    const [selectedSolutions, setSelectedSolutions] = useState(() => getStored('selectedSolutions', []));
    const [selectedCaseType, setSelectedCaseType] = useState(() => getStored('selectedCaseType', []));
    const [selectedCaseSubType, setSelectedCaseSubType] = useState(() => getStored('selectedCaseSubType', []));
    const [selectedBussEntity, setSelectedBussEntity] = useState(() => getStored('selectedBussEntity', []));
    const [filter, setFilter] = useState(() => getStored('laneFilter', null));
    const [optionsKey, setOptionsKey] = useState(0);
    const [optionsKey1, setOptionsKey1] = useState(0);
    const [selectedOwnGroup, setSelectedOwnGroup] = useState(() => getStored('selectedOwnGroup', []));
    const [listBussEntity, setListBussEntity] = useState('');

    const clearDropdownOptions = () => {
        setOptionsKey(prev => prev + 1);
    };
    const clearDropdownOptions1 = () => {
        setOptionsKey1(prev => prev + 1);
    };
    const loadOptionsGroup = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page,
            case_scope: "assigned",
        }
        try {
        const response = await apiService.postRequest(
            `lane-view/filters/ownership-groups`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.display_name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const params = {
                case_scope: "assigned",
            }
            const response = await apiService.postRequest('case_holdings', params);
            if (response.success) {
                const options = response.data.map((business) => ({
                    value: business.id,
                    label: business.name,
                }));
                setListBussEntity(options);
            }
        };
        fetchData();
    }, []);
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page,
            case_scope: "assigned",
        }
        try {
        const response = await apiService.postRequest(
            `lane-view/filters/solutions`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const loadOptionsCaseType = async (searchQuery, loadedOptions, { page }) => {
        const valuesArray = selectedSolutions.map(({ value }) => Number(value));
        const params = {
            solution_id: valuesArray,
            search: searchQuery,
            page : page,
            case_scope: "assigned",
        }
        try {
        const response = await apiService.postRequest(
            `lane-view/filters/case-types`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const loadOptionsSubtype = async (searchQuery, loadedOptions,  { page }) => {
        const valuesArray = selectedCaseType.map(({ value }) => Number(value));
        const solutionArray = selectedSolutions.map(({ value }) => Number(value));
        const params = {
            solution_id: solutionArray,
            case_type_id: valuesArray,
            search: searchQuery,
            page : page,
            case_scope: "assigned",
        }
        try {
        const response = await apiService.postRequest(
            `lane-view/filters/case-sub-types`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
                page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };

    // Lane View
    const MyCaseCard = ({ gCaseLaneData }) => {
        return (
            <div className="scrum-card">
                <div className="card-header d-flex flex-wrap">
                    <Link className='link_datatspan fw-bold' to={`${gCaseLaneData?.case_task_link}`} target='_blank' style={{color:"#C42B7D",textDecoration:"none"}}>
                        {gCaseLaneData?.format_id}
                    </Link>
                    <b className='fw-medium' style={{color:"#000 "}}>{gCaseLaneData?.gcase_summary?.business_entity}</b>
                </div>
                {gCaseLaneData?.gcase_summary?.short_description && <p style={{ marginBottom: '4px' }}>{gCaseLaneData?.gcase_summary?.short_description}</p>}
                {gCaseLaneData?.gcase_summary?.solution && <p style={{ marginBottom: '4px' }}><strong>Solution:</strong> {gCaseLaneData?.gcase_summary?.solution}</p>}
                {gCaseLaneData?.gcase_summary?.case_type && <p style={{ marginBottom: '4px' }}><strong>Case Type:</strong> {gCaseLaneData?.gcase_summary?.case_type}</p>}
                {gCaseLaneData?.gcase_summary?.case_sub_type && <p style={{ marginBottom: '4px' }}><strong>Case Sub Type:</strong> {gCaseLaneData?.gcase_summary?.case_sub_type}</p>}
                {gCaseLaneData?.requested_for && <p style={{ marginBottom: '4px' }}><strong>Requested For:</strong> {gCaseLaneData?.requested_for}</p>}
                {gCaseLaneData?.requested_by && <p style={{ marginBottom: '4px' }}><strong>Requested By:</strong> {gCaseLaneData?.requested_by}</p>}
                {gCaseLaneData?.gcase_summary?.ownership_group && <p className='text-end mb-0 mt-2'><strong style={{color:"#1A5298"}}>{gCaseLaneData?.gcase_summary?.ownership_group}</strong></p>}
            </div>
        );
    };

    const groupByOptions = [
        { value: "stage", label: "Stage" },
        { value: "sub_stage", label: "Sub Stage" },
    ];

    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };
    const toggleLaneview = () => {
        setLaneView((prev) => !prev);
    };

    const [searchQuery, setSearchQuery] = useState(() => getStored('searchQuery', ""));
    const [searchQueryApi, setSearchQueryApi] = useState(() => getStored('searchQueryApi', ""));


    // Tableview with filter
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [loadingPage, setLoadingPage] = useState(false);
    const [applyFilData, setApplyfilData] = useState(() => getStored('applyFilData', []))

    const fetchRoots = useCallback(async (params = {}) => {
        setLoadingApply(true);
        try {
            const defaultParams = {
                case_type: selectedCase,
                case_scope: "assigned",
                per_page: params?.per_page ?? selectedRecord,
                search: searchQueryApi,
                filters: params?.filters ?? applyFilData,
                ...params};
            const response = await apiService.postRequest(`/my-cases`, defaultParams);
            if(response.success === true){
                setMyRequests(response.data);
                setPaginateData(response.meta);
                setShowRecord(response.meta?.per_page)
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
            setLoadingApply(false);
            setLoadingPage(false);
        }
    }, [selectedCase,selectedRecord, applyFilData, searchQueryApi ]);

    const handleSearchTable = () => {
        setApplyfilData(filters);
        fetchRoots({ filters });
        setCurrentPage(1);
    };
    const handleSearchGlobal = () => {
        setSearchQueryApi(searchQuery);
        setCurrentPage(1);
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchRoots({ page: newPage, filters: applyFilData });
        setLoadingPage(true);
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    const [filters, setFilters] = useState(() => getStored('filters', [{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]));

    // 🔹 persist all filter / search / column / case state to session storage
    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedCase', JSON.stringify(selectedCase));
    }, [selectedCase]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'groupByColumn', JSON.stringify(groupByColumn));
    }, [groupByColumn]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'columnVisibility', JSON.stringify(columnVisibilityModel));
    }, [columnVisibilityModel]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'searchQuery', JSON.stringify(searchQuery));
    }, [searchQuery]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'searchQueryApi', JSON.stringify(searchQueryApi));
    }, [searchQueryApi]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'applyFilData', JSON.stringify(applyFilData));
    }, [applyFilData]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'filters', JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedSolutions', JSON.stringify(selectedSolutions));
    }, [selectedSolutions]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedCaseType', JSON.stringify(selectedCaseType));
    }, [selectedCaseType]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedCaseSubType', JSON.stringify(selectedCaseSubType));
    }, [selectedCaseSubType]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedBussEntity', JSON.stringify(selectedBussEntity));
    }, [selectedBussEntity]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedOwnGroup', JSON.stringify(selectedOwnGroup));
    }, [selectedOwnGroup]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'laneFilter', JSON.stringify(filter));
    }, [filter]);

    const combineOptions = [
        { value: 'and', label: 'And' },
        { value: 'or', label: 'Or' },
    ];

    // 🔹 Shared raw-record -> grid-row mapper. Used both for the on-screen
    //    rows and for the export (so exported columns match the table exactly).
    const toRow = (datas) => ({
        id: datas.id,
        gCaseData: datas.gcase_summary,
        formatid: datas.format_id,

        gCaseDescription: datas?.gcase_summary?.short_description,
        gCaseCaseType: datas?.gcase_summary?.case_type,
        gCaseCaseSubType: datas?.gcase_summary?.case_sub_type,
        gCaseBusinessEntity: datas?.gcase_summary?.business_entity,
        gCaseOwnershipGroup: datas?.gcase_summary?.ownership_group,
        gCaseSolution: datas?.gcase_summary?.solution,

        requestedFor : datas.requested_for,
        requestedBy : datas.requested_by,
        assignmentGroup : datas.assignment_group || "N/A",
        assignedTo : datas.assigned_to || "N/A",
        status: datas.status,
        stage: datas.stage,
        subStage: datas.sub_stage,
        createdOn: datas.created_at,
        created_by: datas?.jobseeker?.name,
        onboardSlug: datas.onboarding_slug,
        taskId: datas.task_id,
        casetaskTaskLink: datas.case_task_link,
        requestType: datas.user_request_type,
        type: datas.type,
        onboardUserId: datas.jobseeker_id,
    });

    const rows = myrequests.map(toRow);

    const columnFieldToCSVKey = {
        formatid: 'ID',
        status: 'Status',
        stage: 'Stage',
        subStage: 'Sub Stage',
        gCaseDescription: 'Short Description',
        assignmentGroup: 'Assignment Group',
        assignedTo: 'Assigned To',
        requestedBy: 'Requested By',
        requestedFor: 'Requested For',
        createdOn: 'Created On',
        created_by: 'Jobseeker',
    };

    const getVisibleRowData = (row) => {
        const fullRow = {
            'ID': row.formatid,
            'Status': row.status,
            'Stage': row.stage,
            'Sub Stage': row.subStage,
            ...(selectedCase !== 'onboarding' && {
                'Short Description': row.gCaseDescription,
            }),
            'Assignment Group': row.assignmentGroup,
            'Assigned To': row.assignedTo,
            'Requested By': row.requestedBy,
            'Requested For': row.requestedFor,
            'Created On': row.createdOn,
            ...(selectedCase === 'onboarding' && {
                'Jobseeker': row.created_by,
            }),
        };

        // Filter out hidden columns
        const visibleCSVKeys = Object.entries(columnFieldToCSVKey)
            .filter(([field]) => columnVisibilityModel[field] !== false)
            .map(([, csvKey]) => csvKey);

        return Object.fromEntries(
            Object.entries(fullRow).filter(([key]) => visibleCSVKeys.includes(key))
        );
    };

    // 🔹 Build the body for the server-side table export.
    //    Uses the *applied* search/filters (not the unsaved inputs).
    const buildExportParams = () => ({
        case_scope: "assigned",
        search: searchQueryApi,
        case_type: selectedCase,
        filters: applyFilData,
    });

    // 🔹 Reusable export logic: pulls the FULL filtered dataset from
    //    /my-cases/export, then downloads CSV or copies to clipboard.
    //    Raw records are run through toRow so the visible-column mapper works.
    //    Handles the >10k email prompt and the background-running modal.
    const {
        exporting,
        prompt,
        requestExport,
        confirmEmail,
        confirmContinue,
        cancelPrompt,
    } = useTableExport({
        endpoint: '/my-cases/export',
        endpointMail: '/send-mail-once-exported-the-cases',
        mailFileBase: 'my_cases_export',
        mapRow: (raw) => getVisibleRowData(toRow(raw)),
        fileName: 'my_cases.csv',
    });

    const downloadCSV = () =>
        requestExport('download', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });

    const copyToClipboard = () =>
        requestExport('copy', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });

    const handleFilterChange = (index, field, value) => {
        const updated = [...filters];
        if (field === "column") {
            updated[index][field] = value;
            // Set default operator to "range" when column is created_on
            if (value === "created_on") {
                updated[index].operator = "range";
                updated[index].value = "today";
            } else {
                updated[index].operator = "contains";
                updated[index].value = "";
            }
            delete updated[index].start_date;
            delete updated[index].end_date;
        } else if (field === "value") {
            updated[index].value = value;
            if (value !== "custom") {
                delete updated[index].start_date;
                delete updated[index].end_date;
            }
        } else {
            updated[index][field] = value;
        }

        setFilters(updated);
    };

    const addFilter = () => {
        setFilters([...filters, { logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    const operatorOptions = [
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does Not Contain' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is Not' },
        { value: 'is_empty', label: 'Is Empty' },
        { value: 'is_not_empty', label: 'Is Not Empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'created_on') {
            return [
                { value: 'range', label: 'Range' },
            ];
        }
        return operatorOptions; // Default options
    };


    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.type === "case_management" ?
                    <Link className='case_dataspan' to={`${params.row.casetaskTaskLink}`}>{params.row.formatid}</Link>:
                    <Link className='case_dataspan' to={`${params.row.casetaskTaskLink}`}>{params.row.formatid}</Link>
                    }
                </div>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span className={params.row.status === "Pending" ? "stautuspending" : params.row.status === "Closed" ? "stautusclosed" : "stautusprocess"}>{params.row.status}</span>
                </div>
            )
        },
        {
            field: 'stage',
            headerName: 'Stage',
            width: 350,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.stage}</span>
                </div>
            ),
        },
        {
            field: 'subStage',
            headerName: 'Sub Stage',
            width: 350,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.subStage}</span>
                </div>
            ),
        },
        ...((selectedCase !== 'onboarding')
        ? [{
            field: 'gCaseDescription',
            headerName: 'Short Description',
            width: 300,
            filterable: true,
            renderCell: (params) => (
            <div className='d-flex align-items-center h-100'>
                {params.row.gCaseDescription !== "N/A" ?
                <button className='hisconten_view_btn' onClick={() => handleShow(params.row.gCaseDescription || 'N/A')}>View</button>:
                <span>{params.row.gCaseDescription}</span>}
            </div>
            ),
        }]
        : []),
        {
            field: 'assignmentGroup',
            headerName: 'Assignment Group',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assignmentGroup}</span>
                </div>
            ),
        },
        {
            field: 'assignedTo',
            headerName: 'Assigned To',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assignedTo}</span>
                </div>
            ),
        },
        {
            field: 'requestedBy',
            headerName: 'Requested By',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedBy}</span>
                </div>
            ),
        },
        {
            field: 'requestedFor',
            headerName: 'Requested For',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedFor}</span>
                </div>
            ),
        },
        {
            field: 'createdOn',
            headerName: 'Created On',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.createdOn}</span>
                </div>
            )
        },
        ...((selectedCase === 'onboarding')
        ? [{
            field: 'created_by',
            headerName: 'Jobseeker',
            width: 300,
            filterable: true,
            renderCell: (params) => (
            <div className='d-flex align-items-center h-100'>
                <span>{params.row.created_by}</span>
            </div>
            ),
        }]
        : []),
    ];

    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);

    const handleClose = () => setShow(false);

    const handleShow = (data) => {
        setModalData(data);
        setShow(true);
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{md:6,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Task</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Task <FontAwesomeIcon className='angleright' icon={faAngleRight} /> My Cases</span>
                    </Grid>
                    {!showLaneview &&
                    <Grid size={{md:6,xs:12}} container flexDirection="column" alignContent="flex-end" className="jobseekerhead">
                        <div className="d-flex jobseekersearch my-lg-3" style={{ position: "relative" }}>
                            <div className="col-md-9 input_jobssearch">
                                <FontAwesomeIcon className="iconcol" icon={faMagnifyingGlass} />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e)=> setSearchQuery(e.target.value)}
                                />
                                <button onClick={()=>{setSearchQuery("");setSearchQueryApi("");setCurrentPage(1);}} disabled={!searchQuery} class="close_marksearch">
                                    <FontAwesomeIcon className='px-2' icon={faXmark}/>
                                </button>
                            </div>
                            <div className="col-3">
                                <button
                                onClick={handleSearchGlobal}
                                >Search</button>
                            </div>
                        </div>
                    </Grid>}
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" className="statusselectbtn my-4">
                        <Grid size={{sm:12,xs:12}} container>
                            <TaskTabs/>
                        </Grid>
                    </Grid>
                </Grid>
                {loading ?
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Box sx={{width:"100%"}} className="datatable_jobpagi">
                        {isGridVisible && !showLaneview && (
                        <Box sx={{ mb: 2 }} className="my-4">
                            {filters.map((filter, index) => (
                                <Box key={index} className="d-flex align-items-start flex-wrap">
                                    {index > 0 && (
                                        <select
                                            label="Combine"
                                            value={filter.logic}
                                            onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                            sx={{ mr: 1, minWidth: 80,mb:1 }}
                                        >
                                            {combineOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    )}
                                    <TextField
                                        select
                                        label="Column"
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        <MenuItem value="formatted_id">ID</MenuItem>
                                        <MenuItem value="status">Status</MenuItem>
                                        <MenuItem value="stage">Stage</MenuItem>
                                        <MenuItem value="sub_stage">Sub Stage</MenuItem>
                                        {selectedCase === "general" &&
                                            <MenuItem value="short_description">Short Description</MenuItem>
                                        }
                                        <MenuItem value="assignment_group">Assignment Group</MenuItem>
                                        <MenuItem value="assigned_to">Assigned To</MenuItem>
                                        <MenuItem value="requested_by">Requested By</MenuItem>
                                        <MenuItem value="requested_for">Requested For</MenuItem>
                                        <MenuItem value="created_on">Created On</MenuItem>
                                        {selectedCase !== "general" &&
                                            <MenuItem value="jobseeker">Jobseeker</MenuItem>
                                        }
                                    </TextField>
                                    <TextField
                                        select
                                        label="Operator"
                                        value={filter.operator}
                                        onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        {getOperatorOptions(filter.column).map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {filter.operator === "is_not_empty" || filter.operator === "is_empty" ? "" :<>
                                        {filter.column === 'status' ? (
                                            <select
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ mr: 1, minWidth: 120,mb:1 }}
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value="In-progress">In-progress</option>
                                                <option value="Completed">Completed</option>
                                                <option value="New">New</option>
                                                <option value="Rejected">Rejected</option>
                                                {selectedCase !== "general" &&<>
                                                <option value="hold">Hold</option>
                                                <option value="suspend">Suspend</option></>}
                                            </select>
                                        ) : (filter.column === 'created_on') ? (
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <TextField
                                                    select
                                                    label="Value"
                                                    value={filter.value || "today"}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                    sx={{ minWidth: 120,mb:1 }}
                                                >
                                                    <MenuItem value="today">Today</MenuItem>
                                                    <MenuItem value="yesterday">Yesterday</MenuItem>
                                                    <MenuItem value="this_week">This Week</MenuItem>
                                                    <MenuItem value="last_week">Last Week</MenuItem>
                                                    <MenuItem value="this_month">This Month</MenuItem>
                                                    <MenuItem value="last_month">Last Month</MenuItem>
                                                    <MenuItem value="last_3_months">Last 3 Months</MenuItem>
                                                    <MenuItem value="custom">Custom</MenuItem>
                                                </TextField>
                                                {filter.value === "custom" &&
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        className="filterrages mb-2"
                                                        label="Start Date"
                                                        value={filter.start_date ? dayjs(filter.start_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "start_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />

                                                        <DatePicker
                                                        label="End Date"
                                                        className="filterrages mb-2 me-2"
                                                        value={filter.end_date ? dayjs(filter.end_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "end_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />
                                                </LocalizationProvider>}
                                            </Box>
                                        ) :(
                                            <input
                                                className='value_inputfilter mb-2'
                                                placeholder='Value'
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            />
                                        )}</>}
                                    <button className='filterremovebtn mb-2 ms-1' onClick={() => removeFilter(index)}>Remove</button>
                                </Box>
                            ))}
                            <button className='registersendbtn1 mt-2 mb-0' onClick={addFilter}>Add Filter</button>
                            <button className='registersendbtn2 mt-2 mb-0 ms-3' onClick={handleSearchTable}>
                                {loadingApply ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Apply'}
                            </button>
                        </Box>)}
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <div className='d-flex gap-3'>
                                {!showLaneview &&
                                <button className='show_filterbtn' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>}
                                {selectedCase === "general" &&
                                <button className='registersendbtn2 my-0' onClick={toggleLaneview} >
                                    {showLaneview ? "Table view" : "Lane View" }
                                </button>}
                            </div>
                            <div className='d-flex gap-3'>
                                {!showLaneview &&<>
                                <button className='download_csvbtndatatable' onClick={copyToClipboard}>Copy Table <FontAwesomeIcon className='ps-2' icon={faCopy} /></button>
                                <button className='download_csvbtndatatable' onClick={downloadCSV}>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button></>}
                                <select className='pink_rownded_select ' value={selectedCase} onChange={(e) => {setSelectCase(e.target.value); setLoading(true); setCurrentPage(1)}}>
                                    <option value="general">General Case</option>
                                    <option value="onboarding">Onboarding Case</option>
                                </select>
                            </div>
                        </Grid>
                    </Box>
                    {loadingPage ?
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    {(myrequests && myrequests.length === 0) ?
                    <span className='w-100 text-center'>No Data</span> :
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi select_searchindex">
                        {!showLaneview ? (
                            <DataGrid
                                style={{ minHeight: "200px" }}
                                rows={rows}
                                columns={columns}
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar }}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
                            />
                            ) : (
                            <Box sx={{ mt: 2 }}>
                                <Grid size={{xs:12}} container className="d-flex align-items-start flex-wrap gap-3 mb-3 select_index_muilabel">
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Group By</label>
                                        <select
                                            value={groupByColumn}
                                            onChange={(e) => setGroupByColumn(e.target.value)}
                                            className="form-select"
                                            style={{ maxWidth: '100%', display: 'inline-block' }}
                                        >
                                            {groupByOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </Grid>
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Ownership Groups</label>
                                        <AsyncPaginate
                                            isMulti
                                            className="basic-single select_withsearch w-100"
                                            classNamePrefix="select"
                                            loadOptions={loadOptionsGroup}
                                            value={selectedOwnGroup}
                                            placeholder="Select Ownership Group"
                                            additional={{
                                                page: 1,
                                            }}
                                            closeMenuOnSelect={false}
                                            debounceTimeout={300}
                                            onChange={(selectedOption) => {
                                                setSelectedOwnGroup(selectedOption);
                                            }}
                                            cacheUniqs={[]}
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                        />
                                    </Grid>
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Business Entities</label>
                                        <Select
                                            isMulti
                                            className="basic-single select_withsearch w-100"
                                            classNamePrefix="select"
                                            value={selectedBussEntity}
                                            onChange={(selectedOption) => {
                                                setSelectedBussEntity(selectedOption);
                                            }}
                                            closeMenuOnSelect={false}
                                            options={listBussEntity}
                                            placeholder="Select Business Entity"
                                        />
                                    </Grid>
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Solutions</label>
                                        <AsyncPaginate
                                            isMulti
                                            className="basic-single select_withsearch w-100"
                                            classNamePrefix="select"
                                            loadOptions={loadOptions}
                                            value={selectedSolutions}
                                            placeholder="Select Solution"
                                            additional={{
                                                page: 1,
                                            }}
                                            debounceTimeout={300}
                                            closeMenuOnSelect={false}
                                            onChange={(selectedOption) => {
                                                setSelectedSolutions(selectedOption);
                                                clearDropdownOptions();
                                                clearDropdownOptions1();
                                                setSelectedCaseType([]);
                                                setSelectedCaseSubType([]);
                                            }}
                                            cacheUniqs={[]}
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                        />
                                    </Grid>
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Case Types</label>
                                        <AsyncPaginate
                                            isMulti
                                            key={optionsKey1}
                                            className="basic-single select_withsearch w-100"
                                            classNamePrefix="select"
                                            loadOptions={loadOptionsCaseType}
                                            value={selectedCaseType}
                                            placeholder="Select Case Type"
                                            additional={{
                                                page: 1,
                                            }}
                                            debounceTimeout={300}
                                            closeMenuOnSelect={false}
                                            onChange={(selectedOption) => {
                                                setSelectedCaseType(selectedOption);
                                                clearDropdownOptions();
                                                setSelectedCaseSubType([]);
                                            }}
                                            cacheUniqs={[]}
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                        />
                                    </Grid>

                                    {/* Case Sub Type Select */}
                                    <Grid size={{xs:2.8}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Case Sub Types</label>
                                        <AsyncPaginate
                                            isMulti
                                            key={optionsKey}
                                            className="basic-single select_withsearch w-100"
                                            classNamePrefix="select"
                                            loadOptions={loadOptionsSubtype}
                                            value={selectedCaseSubType}
                                            placeholder="Select Case Sub Type"
                                            additional={{
                                                page: 1,
                                            }}
                                            debounceTimeout={300}
                                            closeMenuOnSelect={false}
                                            onChange={(selectedOption) => {
                                                setSelectedCaseSubType(selectedOption);
                                            }}
                                            cacheUniqs={[]}  // ✅ This prevents reloading on menu open/close
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}  // ✅ Accumulate options
                                        />
                                    </Grid>
                                    <Grid size={{xs:6}} container flexDirection="column">
                                        <label style={{ display: 'block', marginBottom: '4px' }}>Created On</label>
                                        <DatePickerCustom value={filter} onChange={setFilter}/>
                                    </Grid>
                                    <Grid size={{xs:12}} container className="mt-2 mb-3 gap-3">
                                        <button className='registersendbtn2 my-0' onClick={handleSearch}>{loadingApply2 ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Apply'}</button>
                                        <button className='registersendbtn1 my-0' onClick={handleClear}>Clear</button>
                                    </Grid>
                                </Grid>
                                {myrequests2.length > 0 ? (
                                    <div className="d-flex mt-3 g-3 scrum_view">
                                        {myrequests2.map((value, index) => {
                                            // const gCaseGroup = groupedGcase()[value] || [];
                                            const columnSize = 'scrum_viewwidthwhole';

                                            return (
                                                <div key={index} className={`${columnSize} p-2`}>
                                                    <div className="scrum-column">
                                                        <h6 className="scrum-title">{value.title}</h6>
                                                        <div className="scrum-count">{value.total}</div>
                                                        <div className="scrum-cards">
                                                            {value?.data?.map((gCaseLaneData, index) => (
                                                                <MyCaseCard key={index} gCaseLaneData={gCaseLaneData} />
                                                            ))}
                                                            <div ref={setObserver(value.group_id, value.has_more)} />

                                                                {/* 👇 Per-lane loading spinner */}
                                                                {laneLoading[value.group_id] && (
                                                                    <div className="text-center py-2">
                                                                        <span className="spinner-border spinner-border-sm" />
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="text-center p-4">
                                        <p>No Data.</p>
                                    </div>
                                )}
                            </Box>
                        )}
                        {!showLaneview && <>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord(value);
                                            setCurrentPage(1);
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];

                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);

                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );

                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }

                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }

                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }

                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid></>
                        }
                    </Box>
                    }</>}
                </>}
            </Grid>

            {/* Short Description modal */}
            <Modal size='lg' centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Short Description</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3 wrap_textnotflow'>{modalData}</Modal.Body>
            </Modal>

            {/* Export modals: background-running + >10k email prompt (table view only) */}
            <ExportDialogs
                exporting={exporting}
                prompt={prompt}
                onEmail={confirmEmail}
                onContinue={confirmContinue}
                onCancel={cancelPrompt}
                loaderSrc={require('../../../assets/pinkloader.gif')}
            />
        </div>
    </div>
  )
}

export default MyCases